import { axiosSaveForm } from '../../api/admin/form';
import {
    axiosSaveEmail,
    axiosEmailAddForm,
    axiosEmailDeleteForm,
} from '../../api/admin/email';

window.FORMSTYLE = '';
window.jsonFormSetting = '';
window.FORMCLASS = '';
window.FIELD_ITEM = '';
window.isFormAdd = false;
window.isFormUpdate = false;
window.logEventForm = {
    add: {},
    remove: {},
    update: {},
};
(function ($) {
    RVwys.plugin['forms'] = true;
    RVwys.form = {};

    RVwys.formTypeSubmit = function (obj) {
        $('.formTypeInOut').hide();
        var id = obj.get(0).id;
        var name = obj.get(0).name;
        $('.' + id).show();
        var fb = parent.$('#frameBody').get(0).contentWindow;
        var oForm = fb.$(FORMCLASS);
        var thkForm = fb.$(FORMCLASS).next('.thankForm');
        var mg = thkForm.closest('.mg');
        oForm.find('#' + name).val(obj.val());

        if (obj.val() == '1') {
            var overlaypanel = $('<div class="overlayFormThk"></div>').css({
                background: '#cccccc',
                opacity: '0.5',
                position: 'absolute',
                'z-index': '10',
                width: mg.width(),
                height: mg.height(),
            });
            thkForm.prepend(overlaypanel);
            fb.$(FORMCLASS).attr('action', $('#form-inputExternal').val());
        } else {
            thkForm.find('.overlayFormThk').remove();
            fb.$(FORMCLASS).attr('action', '');
        }

        oForm.find('#form-typeSubmit').val(obj.val()).attr('value', obj.val());

        RVwys.uikit.formAPIUpdate(oForm);
    };

    $(document).bind('editorReady', function () {
        $(
            '#form-apform-SenderEmail,#form-apform-SenderName,#form-apform-ReplyTo,#form-apformadmin-Recipient'
        ).attr({
            value: parent.wex.email_config.from_address,
            defaultvalue: parent.wex.email_config.from_address,
        });

        $('#saveall').click(function () {
            RVwys.uikit.scanFormSave();
        });

        $('#form-inputExternal').keyup(function () {
            var fb = parent.$('#frameBody').get(0).contentWindow;
            var oForm = fb.$(FORMCLASS);
            RVwys.uikit.formAPIUpdate(oForm);
            oForm.attr('action', $(this).val());
            oForm.find('#form-inputExternal').val($(this).val());
        });
        $('[id^=retagname-]').keyup(function () {
            var fb = parent.$('#frameBody').get(0).contentWindow;
            var oForm = fb.$(FORMCLASS);
            RVwys.uikit.formAPIUpdate(oForm);
            var v = {
                radio: true,
                checkbox: true,
            };
            var thisType = FIELD_ITEM.attr('type')
                ? FIELD_ITEM.attr('type').toLowerCase()
                : FIELD_ITEM.get(0).tagName.toLowerCase();

            if (v[thisType]) {
                // alert(FIELD_ITEM.parent().parent().get(0).className)
                FIELD_ITEM.parent()
                    .parent()
                    .find('input[type=' + thisType + ']')
                    .attr('name', $(this).val());
            } else {
                FIELD_ITEM.attr('name_external', $(this).val());
            }
        });

        $('[id^=revalue-]').keyup(function () {
            var fb = parent.$('#frameBody').get(0).contentWindow;
            var oForm = fb.$(FORMCLASS);
            RVwys.uikit.formAPIUpdate(oForm);

            var thisType = FIELD_ITEM.attr('type')
                ? FIELD_ITEM.attr('type').toLowerCase()
                : FIELD_ITEM.get(0).tagName.toLowerCase();

            FIELD_ITEM.attr('value', $(this).val());
        });

        $('[id^=phd-]').keyup(function () {
            var fb = parent.$('#frameBody').get(0).contentWindow;
            var oForm = fb.$(FORMCLASS);
            RVwys.uikit.formAPIUpdate(oForm);
            FIELD_ITEM.val('');
            FIELD_ITEM.attr('placeholder', $(this).val());
        });
        $('[id^=valid-]').change(function () {
            var fb = parent.$('#frameBody').get(0).contentWindow;
            var oForm = fb.$(FORMCLASS);
            RVwys.uikit.formAPIUpdate(oForm);
            FIELD_ITEM.attr('valid', $(this).val());
        });

        $('[id^=validmax-]').change(function () {
            var fb = parent.$('#frameBody').get(0).contentWindow;

            var oForm = fb.$(FORMCLASS);
            RVwys.uikit.formAPIUpdate(oForm);

            var max = parseInt($(this).val());
            var isMin =
                FIELD_ITEM.attr('valid-min') == undefined
                    ? 0
                    : FIELD_ITEM.attr('valid-min');
            var min = parseInt(isMin);

            if (!(max > min)) {
                max = $(this).val(min);
            }

            FIELD_ITEM.attr('valid-max', $(this).val());
        });

        $('[id^=validmin-]').change(function () {
            var fb = parent.$('#frameBody').get(0).contentWindow;
            var oForm = fb.$(FORMCLASS);
            RVwys.uikit.formAPIUpdate(oForm);

            var min = parseInt($(this).val());
            var isMax =
                FIELD_ITEM.attr('valid-max') == undefined
                    ? 24
                    : FIELD_ITEM.attr('valid-max');
            var max = parseInt(isMax);

            if (!(min < max)) {
                min = $(this).val(max);
            }

            FIELD_ITEM.attr('valid-min', min);
        });

        $('[id^=required-]').click(function () {
            var fb = parent.$('#frameBody').get(0).contentWindow;
            var oForm = fb.$(FORMCLASS);
            RVwys.uikit.formAPIUpdate(oForm);
            FIELD_ITEM.closest('.uk-form-controls').attr(
                'req',
                $(this).is(':checked')
            );
            FIELD_ITEM.attr('req', $(this).is(':checked'));
        });

        $('#email-Recipient').click(function () {
            var fb = parent.$('#frameBody').get(0).contentWindow;
            var oForm = fb.$(FORMCLASS);
            RVwys.uikit.formAPIUpdate(oForm);
            FIELD_ITEM.attr('recp', $(this).is(':checked'));
        });

        $('#sendToUser,#sendToAdmin').click(function () {
            var fb = parent.$('#frameBody').get(0).contentWindow;
            var oForm = fb.$(FORMCLASS);
            var isCheck = $(this).prop('checked');
            var id = $(this).get(0).id;
            $('.' + id).toggle(isCheck);

            oForm.find('#form-' + id).val(isCheck);
        });

        $(
            '#apform-subject,#apform-SenderEmail,#apform-SenderName,#apform-ReplyTo' +
                ',#apformadmin-subject,#apformadmin-Recipient'
        ).keyup(function () {
            var fb = parent.$('#frameBody').get(0).contentWindow;
            var id = $(this).get(0).id;
            const type = $(this).get(0).type;

            switch (type) {
                case 'email':
                    var isEmail = validator.isEmail($(this).val());
                    if (isEmail) {
                        $(this).next().addClass('uk-hidden');

                        fb.$('#form-' + id).attr({
                            value: $(this).val(),
                            defaultValue: $(this).val(),
                        });
                        var oForm = fb.$(FORMCLASS);
                        RVwys.uikit.formAPIUpdate(oForm);
                    } else {
                        $(this).next().removeClass('uk-hidden');
                    }

                    break;

                default:
                    fb.$('#form-' + id).attr({
                        value: $(this).val(),
                        defaultValue: $(this).val(),
                    });

                    var oForm = fb.$(FORMCLASS);
                    RVwys.uikit.formAPIUpdate(oForm);
                    break;
            }
        });

        // TODO::@Siriluk @warithar move to 7.4
        // $("#apformadmin-Name").keyup(function() {
        //     var fb = parent.$("#frameBody").get(0).contentWindow;
        //     var id = $(this).get(0).id;
        //     // var attrname = $(this).attr("form-name");
        //     console.log("#form-" + id);

        //     fb.$("#form-" + id).attr({
        //         "form-name": $(this).val()
        //     });
        //     //
        //     var oForm = fb.$(FORMCLASS);
        //     RVwys.uikit.formAPIUpdate(oForm);
        // });

        $('input[name=form-typeSubmit]').click(function () {
            RVwys.formTypeSubmit($(this));
        });

        $('.form-position').click(function () {
            frameBody = parent.$('#frameBody').get(0);
            var fb = frameBody.contentWindow;
            var fclass = FORMCLASS.replace('#', '');
            frameBody.contentWindow
                .$(fclass)
                .removeClass(
                    'uk-form-horizontal uk-form-label-right uk-form-label-left'
                );
            frameBody.contentWindow.$(fclass).addClass($(this).attr('cmd'));
            var oForm = fb.$(fclass);
            RVwys.uikit.formAPIUpdate(oForm);
        });

        $('#formWidth-slider').slider({
            slide: function (event, ui) {
                frameBody = parent.$('#frameBody').get(0);
                var fb = frameBody.contentWindow;
                var fWidth = ui.value + '%';
                var fclass = FORMCLASS.replace('#', '');
                $('#chDisplayForm').text(fWidth);
                jsonFormSetting['children'][fclass]['attributes'][
                    'width'
                ] = fWidth;
                var css = CSSJSON.toCSS(jsonFormSetting);
                FORMSTYLE.html(css);
                var oForm = fb.$(fclass);
                RVwys.uikit.formAPIUpdate(oForm);
            },
        });
        $(
            '.form-Color,.form-HeaderColor,.form-HeaderColor,.form-HeaderBorderColor' +
                ',.form-inputColor,.form-inputBorderColor,.form-button,.form-FontColor,.form-stripedOdd,.form-stripedEven'
        ).spectrum({
            showAlpha: true,
            showInput: true,
            allowEmpty: true,
            preferredFormat: 'rgb',
            beforeShow: function () {
                var cObj = $(this);
                var fontAction = $(this).attr('cmd');
                var rangeFontColor = false;
                var overlaypanel = $('<div class="overlaypanel"></div>').css({
                    'background-color': 'red',
                    opacity: '0.0',
                    position: 'absolute',
                    left: '0px',
                    top: '0px',
                    width: $('body').width(),
                    height: $('body').height(),
                });
                parent.$('body').prepend(overlaypanel);

                $(RVwys.currentiFrame).bind('keydown', RVwys.unkeydown);
            },
            show: function (color) {},
            move: function (color) {
                console.log($(this).get(0).id);
                var key = $(this).get(0).id;
                var keyClass = RVwys.form[key]['class'];
                var keyCss = RVwys.form[key]['css'];
                //RVwys.setFormColor(color);
                jsonFormSetting['children'][keyClass]['attributes'][
                    keyCss
                ] = color;
                var css = CSSJSON.toCSS(jsonFormSetting);
                FORMSTYLE.html(css);
            },

            hide: function (color) {
                var key = $(this).get(0).id;
                var keyClass = RVwys.form[key]['class'];
                var keyCss = RVwys.form[key]['css'];
                //RVwys.setFormColor(color);
                jsonFormSetting['children'][keyClass]['attributes'][
                    keyCss
                ] = color;
                var css = CSSJSON.toCSS(jsonFormSetting);
                FORMSTYLE.html(css);

                parent.$('.overlaypanel').remove();
                parent.$(document).unbind('click.spectrum');
                $(RVwys.currentiFrame).unbind('keydown', RVwys.unkeydown);
                var fc = FORMCLASS.replace('#', '');
                var fb = parent.$('#frameBody').get(0).contentWindow;
                var oForm = fb.$(fc);
                RVwys.uikit.formAPIUpdate(oForm);
            },
        });
    });

    $(document).bind('designReady', function (e) {
        if (
            $(
                '.imglogin-user,.imgregister,.imglogin-admin,.imgaccount,.imgresetpassword,.imgexpired'
            )
                .eq(0)
                .get(0)
        ) {
            $('.listFormsAPI').hide();
        }
        $('.listFormsAPI').click(function () {
            RVwys.uikit.loadFormAPI();
        });
    });
    RVwys.designViewAddEvent('mouseup keydown', function (e) {});
    RVwys.uikit.loadFormAPI = function () {
        $('.section-field').toggle(parent.clickFromEdit);
        $('#forms-sortable').toggle(!parent.clickFromEdit);
        $('#forms-item-sortable').toggle(parent.clickFromEdit);

        if ($('#forms-sortable').html() == '') {
            //var s =  parent.SGL_JS_WEBROOT +'/UikitTemplate/uikit_block_design/100/formdesign.html';
            var request = $.ajax({
                method: 'POST',
                url: parent.wex.cdn.cdnFormDesign,
                dataType: 'html',
            });

            /*replace  rvs_library*/
            request.done(function (data) {
                if (data != '') {
                    //./rvsitebuilder/rvs_library/

                    var pats2 = new RegExp(/\[\[CDN_URL\]\]/, 'img');
                    data = data.replace(pats2, function (m, i) {
                        return parent.wex.cdn.cdnURL;
                    });

                    pats2 = new RegExp('../rvsitebuilder/rvs_library/', 'img');
                    data = data.replace(pats2, function (m, i) {
                        return parent.wex.cdn.LIBRARY_URL + '/';
                    });

                    var pats = new RegExp(
                        '../rvsitebuilder/UikitTemplate/uikit_block_design/(25|33|50|66|75|100)/images/',
                        'img'
                    );
                    data = data.replace(pats, function (m, i) {
                        return (
                            parent.wex.url.SGL_JS_WEBROOT +
                            '/UikitTemplate/uikit_block_design/' +
                            i +
                            '/images/'
                        );
                    });
                }
                $('#forms-sortable').html('');
                var oRolsBlock = $('<div/>').html(data);
                oRolsBlock.find('icon').each(function () {
                    $('#forms-sortable').append(
                        $(this)
                            .find('.hvr-glow')
                            .attr({
                                data: $(this).next('design').html(),
                                form: $(this).attr('form'),
                            })
                    );
                });
                setTimeout(function () {
                    RVwys.uikit.formSortable();
                    content_class('rv-widget-form');
                }, 500);
            });
            request.fail(function (jqXHR, textStatus) {
                alert('cannot load form');
                //RVwys.uikit.loadFormDesign();
            });
        }

        if ($('#forms-item-sortable').html() == '') {
            var request = $.ajax({
                method: 'POST',
                url: parent.wex.cdn.cdnFormItem,
                dataType: 'html',
            });

            /*replace  rvs_library*/
            request.done(function (data) {
                if (data != '') {
                    //replace CDN_URL
                    var pats2 = new RegExp(/\[\[CDN_URL\]\]/, 'img');
                    data = data.replace(pats2, function (m, i) {
                        return parent.wex.cdn.cdnURL;
                    });

                    pats2 = new RegExp('../rvsitebuilder/rvs_library/', 'img');
                    data = data.replace(pats2, function (m, i) {
                        return parent.wex.cdn.LIBRARY_URL + '/';
                    });

                    var pats = new RegExp(
                        '../rvsitebuilder/UikitTemplate/uikit_block_design/(25|33|50|66|75|100)/images/',
                        'img'
                    );
                    data = data.replace(pats, function (m, i) {
                        return (
                            parent.wex.url.SGL_JS_WEBROOT +
                            '/UikitTemplate/uikit_block_design/' +
                            i +
                            '/images/'
                        );
                    });
                }
                $('#forms-item-sortable').html('');
                var oRolsBlock = $('<div/>').html(data);
                oRolsBlock.find('icon').each(function () {
                    $('#forms-item-sortable').append(
                        $(this)
                            .find('.hvr-glow')
                            .attr('data', $(this).next('design').html())
                    );
                });
                setTimeout(function () {
                    RVwys.uikit.formItemSortable();
                }, 500);
            });
            request.fail(function (jqXHR, textStatus) {
                alert('cannot load form');
                //RVwys.uikit.loadFormDesign();
            });
        }
    };
    RVwys.uikit.formAPIAdd = function (fm) {
        var id = fm.attr('id');
        parent.logEventForm.add[id] = true;
        console.log('form add');
        console.log(parent.logEventForm.add);
    };

    RVwys.uikit.formAPIUpdate = function (fm) {
        var id = fm.attr('id');

        parent.logEventForm.update[id] = true;
        console.log('form update');
    };

    RVwys.uikit.formAPIRemove = function (fm) {
        var id = fm.attr('id');
        parent.logEventForm.remove[id] = true;
        console.log('form remove');
        console.log(parent.logEventForm.remove);
    };

    RVwys.uikit.firstjsonFormSave = function (data, isiframe, page_id) {
        var isFormAdd = RVwys.uikit.jsonFormSave(data, 'add', isiframe);
        if (isFormAdd) {
            saveFrormData(page_id);
        }
    };

    RVwys.uikit.jsonFormSave = function (data, event, allContent = null) {
        if (allContent == null) {
            var fb = parent.$('#frameBody').get(0).contentWindow;
        }
        var str = {
            req: 'required',
            'valid-max': 'max',
            'valid-min': 'min',
        };
        var adminRule = {
            req: 'required',
            'valid-max': 'max',
            'valid-min': 'min',
        };
        var isreturn = false;
        $.each(data, function (k, v) {
            isreturn = true;
            if (allContent !== null) {
                var datastyle = $(
                    '<style cmd=' +
                        k +
                        '>' +
                        allContent.find('style[cmd="' + k + '"]').html() +
                        '</style>'
                );
                var dataHTML = $('<div/>').append(
                    allContent.find('#' + k).clone()
                );
            } else {
                var datastyle = $(
                    '<style cmd=' +
                        k +
                        '>' +
                        fb.$('style[cmd="' + k + '"]').html() +
                        '</style>'
                );
                var dataHTML = $('<div/>').append(fb.$('#' + k).clone());
            }
            var field_data = {};
            var setting = {};
            dataHTML.find('input,select,textarea').each(function () {
                var oValid = new Array();
                if (
                    $(this)
                        .get(0)
                        .id.match(/rv-form|rv-field/gim)
                ) {
                    field_data[$(this).get(0).id] = {};
                    if ($(this).attr('req') && $(this).attr('req') == 'true') {
                        oValid.push('required');
                    }

                    if ($(this).attr('valid-max')) {
                        oValid.push('max:' + $(this).attr('valid-max'));
                    }
                    if ($(this).attr('valid')) {
                        oValid.push($(this).attr('valid'));
                    }

                    if ($(this).attr('valid-min')) {
                        oValid.push('min:' + $(this).attr('valid-min'));
                    }

                    if ($(this).attr('recp')) {
                        field_data[$(this).get(0).id]['recp'] = $(this).attr(
                            'recp'
                        );
                    }

                    field_data[$(this).get(0).id][
                        'validation_rules'
                    ] = oValid.join('|');

                    field_data[$(this).get(0).id]['value'] = $(this).val();
                    field_data[$(this).get(0).id]['name'] = $(this).attr(
                        'name'
                    );
                    field_data[$(this).get(0).id]['field_name'] = $(this).attr(
                        'name_external'
                    )
                        ? $(this).attr('name_external')
                        : $(this).attr('name');
                    field_data[$(this).get(0).id]['type'] = $(this).attr('type')
                        ? $(this).attr('type')
                        : $(this).get(0).tagName;
                } else {
                    setting[$(this).get(0).id] = {};
                    setting[$(this).get(0).id]['value'] = $(this).val();
                }
            });
            logEventForm[event][k] = {
                data: datastyle.html() + dataHTML.html(),
                field_data: field_data,
                setting: setting,
            };
            //dataHTML
        });
        console.log('real->');
        console.log(logEventForm);
        return isreturn;
    };

    function saveFrormData(page_id) {
        setTimeout(function () {
            var data = logEventForm;
            data.page_id = page_id;

            axiosSaveForm(data)
                .then(result => {
                    logEventForm = {
                        add: {},
                        remove: {},
                        update: {},
                    };
                    parent.logEventForm = {
                        add: {},
                        remove: {},
                        update: {},
                    };
                    isFormAdd = false;
                    isFormUpdate = false;
                })
                .catch(err => {
                    logEventForm = {
                        add: {},
                        remove: {},
                        update: {},
                    };
                    parent.logEventForm = {
                        add: {},
                        remove: {},
                        update: {},
                    };
                    isFormAdd = false;
                    isFormUpdate = false;
                });

            RVwys.uikit.addEmailForm(data.add);
            RVwys.uikit.updateEmailForm(data.update);
        }, 500);
    }

    RVwys.uikit.scanFormSave = function () {
        $.each(logEventForm.add, function (k, v) {
            delete logEventForm.update[k];
        });
        if (logEventForm.remove) {
            RVwys.uikit.deleteEmailForm(logEventForm.remove);
        }

        $.each(logEventForm.remove, function (k, v) {
            if (logEventForm.add[k]) {
                delete logEventForm.add[k];
                delete logEventForm.remove[k];
            }
            delete logEventForm.update[k];
        });

        isFormAdd = RVwys.uikit.jsonFormSave(logEventForm.add, 'add');
        isFormUpdate = RVwys.uikit.jsonFormSave(logEventForm.update, 'update');
        var page_id = $('#frameBody')
            .contents()
            .find("input[name^='page_id']")
            .val();
        if (isFormAdd || isFormUpdate) {
            saveFrormData(page_id);
        }
    };

    RVwys.uikit.addEmailForm = function (data) {
        var page_name = $('#cmsCurrent').text();
        var ele_begin =
            '<div class="container" style="text-align:center; padding:50px 20px; background-color: #FFFFFF; font-family: Avenir, Helvetica, sans-serif; box-sizing: border-box; min-height: 180px;">';
        var ele_end = '</div>';
        $.each(data, function (i, v) {
            //Admin
            var result = v.data.match(/(.*?)(<form.*?>.*?<\/form>)/s);

            var content_view = RVwys.save.removeEle.contentViewmode(
                $('<div>').html(result[2])
            );
            content_view = RVwys.save.removeClass.contentViewmode(content_view);
            content_view = RVwys.save.replaceEle.contentViewmode(content_view);
            var typeForm = [{ type: 'admin' }, { type: 'user' }];

            typeForm.forEach(itemType => {
                var contentEdit =
                    itemType.type == 'admin'
                        ? result[2]
                        : v.setting['form-apform-subject']['value'];

                var contentView =
                    itemType.type == 'admin'
                        ? content_view.html()
                        : v.setting['form-apform-subject']['value'];

                var emailSubject =
                    itemType.type == 'admin'
                        ? v.setting['form-apformadmin-subject']['value']
                        : v.setting['form-apform-subject']['value'];

                axiosEmailAddForm({
                    form_type: itemType.type,
                    css_style: itemType.type == 'admin' ? result[1] : '',
                    content_edit: ele_begin + contentEdit + ele_end,
                    content_view: ele_begin + contentView + ele_end,
                    form_attr_id: i,
                    email_name: page_name ? `${page_name}_${i}` : i,
                    email_subject: emailSubject,
                })
                    .then(result => {
                        console.log('result: ', result.data);
                    })
                    .catch(err => {
                        console.pop.error({
                            text: `Status Code: ${err.status} ( ${err.statusText} )
                                Message : ${err.data.message}`,
                            delay: 5000,
                        });
                    });
            });
        });
    };

    RVwys.uikit.updateEmailForm = function (data) {
        var ele_begin =
            '<div class="container" style="text-align:center; padding:50px 20px; background-color: #FFFFFF; font-family: Avenir, Helvetica, sans-serif; box-sizing: border-box; min-height: 180px;">';
        var ele_end = '</div>';
        $.each(data, function (i, v) {
            //Admin
            var result = v.data.match(/(.*?)(<form.*?>.*?<\/form>)/s);
            var content_view = RVwys.save.removeEle.contentViewmode(
                $('<div>').html(result[2])
            );
            content_view = RVwys.save.removeClass.contentViewmode(content_view);
            content_view = RVwys.save.replaceEle.contentViewmode(content_view);

            var typeForm = [{ type: 'admin' }, { type: 'user' }];
            typeForm.forEach(typeForm => {
                var odjData = {
                    savetype: 'content',
                    form_type: typeForm.type,
                    email_type: 'email',
                    content_style: result[1],
                    content_edit: ele_begin + result[2] + ele_end,
                    content_view: ele_begin + content_view.html() + ele_end,
                    form_attr_id: i,
                    email_subject:
                        v.setting['form-apformadmin-subject']['value'],
                };

                if (typeForm.type == 'user') {
                    var content_edit_user = v.setting['form-apform-subject'][
                        'value'
                    ]
                        ? `${ele_begin}${v.setting['form-apform-subject']['value']}${ele_end}`
                        : '';

                    var content_view_user = v.setting['form-apform-subject'][
                        'value'
                    ]
                        ? `${ele_begin}${v.setting['form-apform-subject']['value']}${ele_end}`
                        : '';

                    odjData.content_edit = content_edit_user;
                    odjData.content_view = content_view_user;
                    odjData.email_subject =
                        v.setting['form-apform-subject']['value'];
                }

                axiosSaveEmail(odjData)
                    .then(result => {
                        if (result.data.status == 'error') {
                            console.pop.error({
                                title: `Save e-mail: ${typeForm.type}`,
                                text: result.data.response_msg,
                            });
                        }
                    })
                    .catch(err => {
                        console.pop.error({
                            text: err.data.message,
                        });

                        setTimeout(function () {
                            oThis.afterError();
                        }, 1000);
                    });
            });
        });
    };

    RVwys.uikit.deleteEmailForm = function (data) {
        $.each(data, function (formID, v) {
            axiosEmailDeleteForm({
                form_attr_id: formID,
            })
                .then(result => {
                    console.log('result: ', result.data);
                })
                .catch(err => {
                    console.log('err: ', err.data);
                });
        });
    };

    RVwys.uikit.formInputMousedown = function (othis) {
        if (!$(othis).hasAnyClass('txtloginEmail txtloginPassword')) {
            if (othis.attr('type') == 'radio') {
                parent.$('#email-Recipient').prop('checked', recp);
                var oType = 'radio';
            } else {
                var isSelect = othis.prop('tagName').toLowerCase();
                var oType =
                    isSelect == 'select' || isSelect == 'textarea'
                        ? isSelect
                        : othis.attr('type');
            }
            parent.FIELD_ITEM = othis;
            var isNot = {
                undefined: 'none',
                false: 'none',
                true: 'none',
            };
            var req = othis.attr('req') || 'true';
            var recp = othis.attr('recp') || 'true';
            var valid = isNot[othis.attr('valid')]
                ? isNot[othis.attr('valid')]
                : othis.attr('valid');
            var validMax = isNot[othis.attr('valid-max')]
                ? isNot[othis.attr('valid-max')]
                : othis.attr('valid-max');
            var validMin = isNot[othis.attr('valid-min')]
                ? isNot[othis.attr('valid-min')]
                : othis.attr('valid-min');
            var tagname = othis.attr('name_external')
                ? othis.attr('name_external')
                : othis.attr('name');

            if (oType == 'email') {
                parent.$('#email-Recipient').prop('checked', recp);
            }
            parent.$('#required-' + oType).prop('checked', req);
            parent.$('#valid-' + oType).val(valid);
            parent.$('#validmax-' + oType).val(validMax);
            parent.$('#validmin-' + oType).val(validMin);
            parent.$('#phd-' + oType).val(othis.attr('placeholder'));
            parent.$('#retagname-' + oType).val(tagname);
            parent.$('#revalue-' + oType).val(othis.val());

            parent.$('.wys-panel').hide(0, function () {
                parent.$('.wys-rowfFieldSeting').show();
                parent.$('.propFm').hide(0, function () {
                    parent.$('#propFm-' + oType).show();
                });
            });
        }
    };
    RVwys.uikit.formReceiEvent = function (thisObj) {
        thisObj
            .find('.uk-form')
            .unbind('mousedown')
            .mousedown(function () {
                //alert('w')
                RVwys.uikit.loadFormAPI();
                parent.clickFromEdit = true;
                parent.oFormUIKIT = $(this).parent();
                //alert($(this).get(0).id)
                parent.FORMCLASS = '#' + $(this).get(0).id.replace('.', '');
                $('.section-form').removeClass('active-section-name');
                $('.section-field').addClass('active-section-name').show();
                $('#forms-sortable').hide();
                $('#forms-item-sortable, .rv-group-panel').show();
                //$('.menuLeftOut').addClass('menuLeftOver').removeClass('menuLeftOut');
                //$('.leftMenu-hover').removeClass('leftMenu-hover');
            })
            .each(function () {
                RVwys.uikit.formOption($(this));
            })
            .find('input,textarea,select')
            .unbind('mousedown')
            .mousedown(function () {
                // alert('w');
                RVwys.uikit.formInputMousedown($(this));
            })
            .unbind('click')
            .click(function () {
                return false;
            });
    };
    RVwys.uikit.htmlThankForm = function (oForm) {
        oForm.after(parent.$('.thankForm').clone());
    };
    RVwys.uikit.formDefaultEmail = function (oForm) {
        oForm.append(parent.$('.formDefaultMail').clone());
        //isEmail  = Boolean(oForm.find('[type="email"]').length);

        //oForm.find('#form-sendToUser').val(isEmail);
    };

    RVwys.uikit.checkEmail = function (oForm) {
        if (oForm.get(0)) {
            var isEmail = Boolean(oForm.find('[type="email"]').length);
            var useEmail = oForm.find('#form-sendToUser').val() || 'true';
            if (!isEmail && useEmail) {
                oForm.find('#form-sendToUser').val(isEmail);
            }
        }
    };
    RVwys.uikit.formOption = function (oForm) {
        // alert('option')
        oForm.find('.fm-editOption').remove();
        oForm.find('a[cmd="edit"]').remove();
        var buttonEdit =
            '<a href="javascript:void(0)" class="fm-editOption uk-form-controls" cmd="edit"><i class="uk-icon uk-icon-edit"></i> Edit</a>';
        oForm.find('select').after(
            $(buttonEdit).click(function () {
                switch ($(this).attr('cmd')) {
                    case 'edit':
                        $(this).attr('cmd', 'close');
                        $(this).html(
                            '<i class="uk-icon uk-icon-check"></i> Ok'
                        );
                        var textAr = $(
                            '<textarea class="uk-form-controls customFromAPI" style="height:100px; border:dotted 1px #55d44c; display:block;"></textarea>'
                        );
                        $(this).before(textAr);
                        //alert($(this).parent().find('select').get(0))
                        textAr.append(
                            $(this)
                                .parent()
                                .find('select option')
                                .map(function () {
                                    var inputCurrent = $(this).prop('selected')
                                        ? '##'
                                        : '';
                                    return $(this).text() + inputCurrent;
                                })
                                .get()
                                .join('\n')
                        );

                        break;
                    case 'close':
                        var aText = $(this)
                            .parent()
                            .find('textarea')
                            .val()
                            .split('\n');
                        var oSelect = $(this).parent().find('select');
                        oSelect.html('');
                        $.each(aText, function (k, v) {
                            var isDefault = false;
                            var txt = v.replace('##', function (i) {
                                isDefault = 'selected';
                                return '';
                            });

                            oSelect.append(
                                $(
                                    '<option value="' +
                                        txt +
                                        '">' +
                                        txt +
                                        '</option>'
                                ).attr('selected', isDefault)
                            );
                        });
                        $(this).attr('cmd', 'edit');
                        $(this).html(
                            '<i class="uk-icon uk-icon-edit"></i> Edit'
                        );
                        $(this).parent().find('textarea').remove();
                        break;
                    default:
                        break;
                }
            })
        );

        oForm.find('.rv-radio-lineup,.rv-radio-inline').after(
            $(buttonEdit).click(function (e) {
                switch ($(this).attr('cmd')) {
                    case 'edit':
                        $(this).attr('cmd', 'close');
                        $(this).html(
                            '<i class="uk-icon uk-icon-check"></i> Ok'
                        );
                        var textAr = $(
                            '<textarea class="uk-form-controls" style="height:100px; border:dotted 1px #55d44c; display:block;"></textarea>'
                        );
                        $(this).before(textAr);
                        //alert($(this).parent().find('select').get(0))
                        var a = $(this)
                            .parent()
                            .find('input[type=radio],input[type=checkbox]')
                            .map(function () {
                                textAr.attr('tag', $(this).attr('type'));
                                var inputCurrent = $(this).prop('checked')
                                    ? '##'
                                    : '';
                                return $(this).parent().text() + inputCurrent;
                            })
                            .get()
                            .join('\n');

                        textAr.append(a);

                        break;
                    case 'close':
                        var texta = $(this).parent().find('textarea');
                        var name =
                            texta.attr('tag') + Math.ceil(event.timeStamp);
                        var aText = texta.val().split('\n');
                        var oSelect = $(this).prev().prev();
                        //alert(oSelect.html())
                        oSelect.html('');
                        $.each(aText, function (k, v) {
                            //alert(v)
                            var isDefault = false;
                            var txt = v.replace('##', function (i) {
                                isDefault = true;
                                return '';
                            });
                            if (texta.attr('tag') == 'checkbox') {
                                var setName = name + '[' + k + ']';
                            } else {
                                var setName = name + '[]';
                            }
                            oSelect.append(
                                $(
                                    '<label><input type="' +
                                        texta.attr('tag') +
                                        '" name="' +
                                        setName +
                                        '" value="' +
                                        txt +
                                        '"/>' +
                                        txt +
                                        '</label>'
                                )
                                    .find('input')
                                    .attr('checked', isDefault)
                                    .end()
                            );
                        });

                        $(this).attr('cmd', 'edit');
                        $(this).html(
                            '<i class="uk-icon uk-icon-edit"></i> Edit'
                        );
                        $(this).parent().find('textarea').remove();
                        RVwys.uikit.formAPIUpdate($(this).closest('form'));
                        break;
                    default:
                        break;
                }
            })
        );
    };

    RVwys.uikit.formItemSortable = function () {
        var startIndex;
        var uiHeight;

        $('#forms-item-sortable')
            .disableSelection()
            .sortable({
                connectWith: '.uk-form .uk-grid',
                opacity: '.5',
                appendTo: 'body',
                sort: function (e, ui) {
                    RVwys.hidemgActive();
                },
                placeholder: {
                    element: function (e, li) {
                        var groupPHB = $(e).get(0).className;
                        console.log(
                            'tpl-block-placeholder->' +
                                groupPHB +
                                'height->' +
                                $(this).height()
                        );
                        var phd = $(
                            $('.tpl-block-placeholder')
                                .html()
                                .replace(/ui-placeholder-block/i, groupPHB)
                            //.replace(/height\:auto\;/i,'height:'+$(this).height()+'px')
                        );
                        return phd[0];
                        //tpl-placeholder
                    },
                    update: function (e, li) {
                        console.log(
                            'update image-editor-tool--->' +
                                parent.$('.image-editor-tool').get(0)
                        );
                        RVwys.imageEditorToolResetPos();
                        return;
                    },
                },
                helper: function (e, li) {
                    this.copyHelper = li.clone().insertAfter(li);
                    $(this).data('copied', false);
                    return $(
                        '<div class="rvSWDhelper" style="height:50px;"></div>'
                    );
                },
                change: function (e, ui) {
                    var changeIndex = ui.placeholder.index();
                    if (startIndex > changeIndex) {
                        var slice = parent.oFormUIKIT
                            .find('[class*=uk-width]')
                            .slice(
                                changeIndex,
                                parent.oFormUIKIT.find('[class*=uk-width]')
                                    .length
                            );

                        slice.not('.ui-sortable-helper').each(function () {
                            var item = $(this);
                            item.css({
                                transform: 'translateY(' + uiHeight + 'px)',
                            });
                        });
                    } else if (startIndex < changeIndex) {
                        var slice = parent.oFormUIKIT
                            .find('[class*=uk-width]')
                            .slice(startIndex, changeIndex);

                        slice.not('.ui-sortable-helper').each(function () {
                            var item = $(this);
                            item.css({
                                transform: 'translateY(0px)',
                            });
                        });
                    }

                    startIndex = changeIndex;
                },
                start: function (event, ui) {
                    if (parent.oFormUIKIT) {
                        parent.oFormUIKIT.find('[class*=uk-width]').css({
                            transition: 'transform .2s',
                            left: '',
                        });
                    }
                    startIndex = ui.placeholder.index();
                    uiHeight = ui.item.outerHeight(true);
                    ui.item
                        .nextAll('[class*=uk-width]:not(.placeholder-block)')
                        .css({
                            transform: 'translateY(' + uiHeight + 'px)',
                        });

                    ui.placeholder.css({
                        height: 0,
                        padding: 0,
                    });
                },
                stop: function (event, ui) {
                    var $uiItem = $(ui.item);
                    if ($uiItem.parent().is('#forms-item-sortable'))
                        $uiItem.remove();
                    parent.oFormUIKIT.find('[class*=uk-width]').css({
                        transform: 'translateY(0)',
                    });
                },
            });
    };
    RVwys.uikit.formSortable = function () {
        $('#forms-sortable')
            .disableSelection()
            .sortable({
                connectWith: '.designBlock',
                opacity: '.5',
                appendTo: 'body',
                sort: function (e, ui) {
                    RVwys.hidemgActive();
                },
                placeholder: {
                    element: function (e, li) {
                        return $($('.tpl-placeholder').html())[0];
                    },
                    update: function (e, li) {
                        console.log(
                            'update image-editor-tool--->' +
                                parent.$('.image-editor-tool').get(0)
                        );
                        RVwys.imageEditorToolResetPos();
                        return;
                    },
                },
                helper: function (e, li) {
                    this.copyHelper = li.clone().insertAfter(li);
                    $(this).data('copied', false);
                    return $('<div class="rvSWDhelper" style=""></div>');
                },
                stop: function (event, ui) {
                    var $uiItem = $(ui.item);
                    if ($uiItem.parent().is('#forms-sortable'))
                        $uiItem.remove();
                },
            });
    };
    RVwys.uikit.panelFormAction = function (othis) {
        parent.nviActive = false;
        $('.menuLeftOver').removeClass('menuLeftOver').addClass('menuLeftOut');
        var mg = $(othis).closest('.mg');
        var oEdArea = $(othis).closest('.editable_area');
        var oForm = mg.find('.uk-form');
        //alert('#'+oForm.get(0).id)
        parent.FORMCLASS = '#' + oForm.get(0).id;
        parent.$('.wys-panel').hide(0, function () {
            parent.$('.wys-rowfFieldAction').show();
        });

        oEdArea.find('.mg').hide();
        mg.show();
        mg.find('.uk-form').hide();
        mg.find('.thankForm').show();
        $('.rightbar').hide();

        $('.thkFormEditor')
            .closest('.mg')
            .find('.navMenu-blockMainSetting')
            .hide();
        //alert(oForm.find('[type="email"]').length)
        var isEmail = Boolean(oForm.find('[type="email"]').length);
        var isSendToAdmin = oForm.find('#form-sendToAdmin').val() === 'true';
        var chkSendToUser = oForm.find('#form-sendToUser').val() === 'true';
        if (!isEmail) chkSendToUser = false;
        parent.$('#sendToUser').prop({
            disabled: !isEmail,
        });
        if (chkSendToUser) {
            parent.$('#sendToUser').attr('checked', 'true');
            parent.$('.sendToUser').show();
        } else {
            parent.$('#sendToUser').removeAttr('checked');
            parent.$('.sendToUser').hide();
        }

        if (isSendToAdmin) {
            parent.$('.sendToAdmin').show();
        } else {
            parent.$('.sendToAdmin').hide();
        }
        console.log('////////////////');

        console.log(oForm.attr('action'));
        console.log(oForm);

        parent.$('#form-inputExternal').val(oForm.attr('action'));
        console.log(oForm.find('#form-typeSubmit').val());

        if (oForm.find('#form-typeSubmit').val() == '1') {
            //1
            var typeSubmit = parent.$('#form-external').prop('checked', true);
        } else {
            var typeSubmit = parent.$('#form-internal').prop('checked', true);
        }

        parent.RVwys.formTypeSubmit(typeSubmit);

        parent
            .$('#apform-subject')
            .val(oForm.find('#form-apform-subject').attr('defaultvalue'));
        parent
            .$('#apform-SenderEmail')
            .val(oForm.find('#form-apform-SenderEmail').attr('defaultvalue'));
        parent
            .$('#apform-SenderName')
            .val(oForm.find('#form-apform-SenderName').attr('defaultvalue'));
        parent
            .$('#apform-ReplyTo')
            .val(oForm.find('#form-apform-ReplyTo').attr('defaultvalue'));
        parent.$('#sendToAdmin').prop({
            checked: isSendToAdmin,
        });
        parent
            .$('#apformadmin-subject')
            .val(oForm.find('#form-apformadmin-subject').attr('defaultvalue'));
        parent
            .$('#apformadmin-Recipient')
            .val(
                oForm.find('#form-apformadmin-Recipient').attr('defaultvalue')
            );

        // TODO::@Siriluk @warithar move to 7.4
        // var isNameForm = oForm.attr("form-name")
        //     ? oForm.attr("form-name")
        //     : oForm.attr("id");
        // parent.$("#apformadmin-Name").val(isNameForm);
    };
    RVwys.uikit.panelFormDesign = function (othis) {
        parent.nviActive = true;
        $('.rightbar').show();
        setTimeout(function () {
            $('.section-form').removeClass('active-section-name');
            $('.section-field').addClass('active-section-name').show();
            $('#forms-sortable').hide();
            $('#forms-item-sortable, .rv-group-panel').show();

            //$('.menuLeftOut').addClass('menuLeftOver').removeClass('menuLeftOut');
            $('.leftMenu-hover').removeClass('leftMenu-hover');
        }, 50);

        var mg = $(othis).closest('.mg');
        parent.FORMCLASS = '#' + mg.find('.uk-form ').get(0).id;
        var oEdArea = $(othis).closest('.editable_area');
        parent.$('.wys-panel').hide(0, function () {
            parent.$('.wys-rowfFieldDesign').show();
        });

        oEdArea.find('.mg').show(0, function () {
            mg.find('.uk-form ').show();
            mg.find('.thankForm').hide();
        });

        var mg = $(othis).closest('.mg');
        var oStyle = mg.find('style');
        // alert(oStyle.get(0))
        if (oStyle.get(0)) {
            var styClass = '.' + oStyle.attr('cmd');
            parent.FORMCLASS = '#' + styClass;
            var inputC =
                styClass +
                ' input:not([type]),' +
                styClass +
                ' input[type=text]' +
                ',' +
                styClass +
                ' input[type=password],' +
                styClass +
                ' input[type=email]' +
                ',' +
                styClass +
                ' input[type=url],' +
                styClass +
                ' input[type=search]' +
                ',' +
                styClass +
                ' input[type=tel],' +
                styClass +
                ' input[type=number]' +
                ',' +
                styClass +
                ' input[type=datetime],' +
                styClass +
                ' input[type=datetime-local]' +
                ',' +
                styClass +
                ' input[type=date],' +
                styClass +
                ' input[type=month]' +
                ',' +
                styClass +
                ' input[type=time],' +
                styClass +
                ' input[type=week]' +
                ',' +
                styClass +
                ' input[type=color],' +
                styClass +
                ' input[type=checkbox]' +
                ',' +
                styClass +
                ' input[type=radio],' +
                styClass +
                ' select,' +
                styClass +
                ' textarea';

            parent.RVwys.form['form-Color'] = {
                class: styClass,
                css: 'background',
            };
            parent.RVwys.form['form-HeaderColor'] = {
                class: styClass + ' .rv-form-header',
                css: 'background',
            };
            parent.RVwys.form['form-HeaderBorderColor'] = {
                class: styClass + ' .rv-form-header',
                css: 'border-color',
            };
            parent.RVwys.form['form-inputColor'] = {
                class: inputC,
                css: 'background',
            };
            parent.RVwys.form['form-inputBorderColor'] = {
                class: inputC,
                css: 'border-color',
            };

            parent.RVwys.form['form-FontColor'] = {
                class: styClass,
                css: 'color',
            };
            parent.RVwys.form['form-button'] = {
                class: styClass + ' .btn-bgcolor',
                css: 'background',
            };

            parent.RVwys.form['form-stripedOdd'] = {
                class: styClass + ' .uk-form-striped > div:nth-of-type(odd)',
                css: 'background',
            };
            parent.RVwys.form['form-stripedEven'] = {
                class: styClass + ' .uk-form-striped > div:nth-of-type(even)',
                css: 'background',
            };

            parent.$('.wys-rowFormDesign').show();
            var mg = $(othis).closest('.mg');
            parent.FORMSTYLE = mg.find('style');
            var styletext = mg.find('style').text();
            //alert(styletext);

            //var re = new RegExp('\/\*[\s\S]*?\*\/|([^\\:]|^)\/\/.*$','img');

            parent.jsonFormSetting = CSSJSON.toJSON(
                styletext
                    .replace(/\/\*[\s\S]*?\*\/|([^\\:]|^)\/\/.*$/gim, '')
                    .replace(/\,\s*/gim, ',')
                    .replace(/\s?\>\s?/gim, ' > ')
            );
            console.log(parent.jsonFormSetting);
            var fWidth =
                parent.jsonFormSetting['children'][
                    parent.RVwys.form['form-Color']['class']
                ]['attributes']['width'];
            var fColor =
                parent.jsonFormSetting['children'][
                    parent.RVwys.form['form-Color']['class']
                ]['attributes']['background'];
            var finputColor =
                parent.jsonFormSetting['children'][
                    parent.RVwys.form['form-inputColor']['class']
                ]['attributes']['background'];
            var fHeadColor =
                parent.jsonFormSetting['children'][
                    parent.RVwys.form['form-HeaderColor']['class']
                ]['attributes']['background'];
            var fHeadBorderColor =
                parent.jsonFormSetting['children'][
                    parent.RVwys.form['form-HeaderColor']['class']
                ]['attributes']['border-color'];
            var fInputBorderColor =
                parent.jsonFormSetting['children'][
                    parent.RVwys.form['form-inputBorderColor']['class']
                ]['attributes']['border-color'];
            var fFontColor =
                parent.jsonFormSetting['children'][
                    parent.RVwys.form['form-FontColor']['class']
                ]['attributes']['color'];
            var fButtonColor =
                parent.jsonFormSetting['children'][
                    parent.RVwys.form['form-button']['class']
                ]['attributes']['background'];
            var fStripedOdd =
                parent.jsonFormSetting['children'][
                    parent.RVwys.form['form-stripedOdd']['class']
                ]['attributes']['background'];
            var fStripedEven =
                parent.jsonFormSetting['children'][
                    parent.RVwys.form['form-stripedEven']['class']
                ]['attributes']['background'];

            fWidth = fWidth == 'auto' ? '100%' : fWidth;
            //alert(fWidth)
            parent
                .$('#formWidth-slider')
                .slider('option', 'value', fWidth.replace('%', ''));
            parent.$('#chDisplayForm').text(fWidth);
            parent
                .$('.form-Color')
                .spectrum('set', RVwys.formReplaceCSS(fColor));
            parent
                .$('.form-FontColor')
                .spectrum('set', RVwys.formReplaceCSS(fFontColor));
            parent
                .$('.form-HeaderColor')
                .spectrum('set', RVwys.formReplaceCSS(fHeadColor)); // form color;
            parent
                .$('.form-HeaderBorderColor')
                .spectrum('set', RVwys.formReplaceCSS(fHeadBorderColor));
            //alert(finputColor);
            //alert(RVwys.formReplaceCSS(finputColor));
            parent
                .$('.form-inputColor')
                .spectrum('set', RVwys.formReplaceCSS(finputColor));
            parent
                .$('.form-inputBorderColor')
                .spectrum('set', RVwys.formReplaceCSS(fInputBorderColor));
            parent
                .$('.form-button')
                .spectrum('set', RVwys.formReplaceCSS(fButtonColor));
            parent
                .$('.form-stripedOdd')
                .spectrum('set', RVwys.formReplaceCSS(fStripedOdd));
            parent
                .$('.form-stripedEven')
                .spectrum('set', RVwys.formReplaceCSS(fStripedEven));
        }
    };
    RVwys.formReplaceCSS = function (str) {
        return str.replace('!important', '');
    };
    RVwys.designViewAddEvent('keyup', function (e) {
        var curRange = $(e.target);
        if ($(curRange).hasClass('formEditable')) {
            var fm = $(curRange).closest('.uk-form');
            RVwys.uikit.formAPIUpdate(fm);
        }
    });
})(jQuery);
